import React, { useState, useRef } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  LinearProgress,
  Alert,
  Stack,
  Card,
  CardContent,
  Modal,
  IconButton
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

import { UrlApi } from "../../../../../services/apirest";

const UploadBox = styled(Paper)(({ theme }) => ({
  border: `2px dashed #1F618D`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",
  backgroundColor: "#F4F6F6",
  "&:hover": {
    backgroundColor: "#EBF0F2",
    borderColor: "#0E3E5F",
    boxShadow: "0 4px 12px rgba(31, 97, 141, 0.15)",
  },
}));

const ModalCargaPadron = ({ open, setOpen }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState(null);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFileSelection(droppedFiles);
  };


  const handleFileSelection = (selectedFiles) => {
    const validFiles = selectedFiles.filter(
      (file) => file.name.toLowerCase().endsWith(".zip")
    );

    if (validFiles.length === 0) {
      setUploadStatus({
        type: "error",
        message: "Solo se permite 1 archivo con extensión .tmp",
      });
      return;
    }

    // Solo permitir UN archivo, reemplazar si suben otro
    setFiles([validFiles[0]]);
    setUploadStatus(null);
  };


  const handleInputChange = (e) => {
    if (e.target.files) {
      handleFileSelection(Array.from(e.target.files));
    }
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };


//   const handleUpload = async () => {
//   if (files.length === 0) return;

//   const archivo = files[0];

//   // Validación de tamaño (600MB)
//   const MAX_SIZE = 600 * 1024 * 1024;
//   if (archivo.size > MAX_SIZE) {
//     setUploadStatus({
//       type: "error",
//       message: "El archivo supera el tamaño máximo permitido (600MB)",
//     });
//     return;
//   }

//   setUploading(true);
//   setProgress(0);
//   setUploadStatus({ type: "info", message: "Subiendo archivo..." });

//   try {
//     const formData = new FormData();
//     formData.append("files", archivo); // CAMBIO IMPORTANTE

//     const xhr = new XMLHttpRequest();

//     // Barra de progreso
//     xhr.upload.addEventListener("progress", (e) => {
//       if (e.lengthComputable) {
//         const percent = Math.round((e.loaded / e.total) * 100);
//         setProgress(percent);
//       }
//     });

//     // Respuesta del servidor
//     xhr.addEventListener("load", () => {
//       if (xhr.status === 200) {
//         const resp = JSON.parse(xhr.responseText);

//         setUploadStatus({
//           type: "success",
//           message: resp.message || "Archivo subido correctamente",
//         });

//         setFiles([]);
//         setProgress(100);
//       } else {
//         setUploadStatus({
//           type: "error",
//           message: "Error en el servidor al subir el archivo",
//         });
//       }

//       setUploading(false);
//     });

//     xhr.addEventListener("error", () => {
//       setUploadStatus({
//         type: "error",
//         message: "Error al subir el archivo",
//       });
//       setUploading(false);
//     });

//     xhr.open("POST", `${UrlApi}/proveedores/padron_contribuyentes/upload-zip`);
//     xhr.send(formData);
//   } catch (error) {
//     setUploadStatus({
//       type: "error",
//       message: "Error inesperado al procesar el archivo",
//     });
//     setUploading(false);
//   }
// };

const handleUpload = async () => {
  if (files.length === 0) return;

  const archivo = files[0];

  // Validación de tamaño (600MB)
  const MAX_SIZE = 600 * 1024 * 1024;
  if (archivo.size > MAX_SIZE) {
    setUploadStatus({
      type: "error",
      message: "El archivo supera el tamaño máximo permitido (600MB)",
    });
    return;
  }

  setUploading(true);
  setProgress(0);
  setUploadStatus({ type: "info", message: "Subiendo archivo..." });

  try {
    const formData = new FormData();
    formData.append("files", archivo); // CAMBIO IMPORTANTE

    const xhr = new XMLHttpRequest();

    // Barra de progreso
    xhr.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100);
        setProgress(percent);
      }
    });

    // Respuesta del servidor
    xhr.addEventListener("load", () => {
      if (xhr.status === 200) {
        const resp = JSON.parse(xhr.responseText);

        setUploadStatus({
          type: "success",
          message: resp.message || "Archivo subido correctamente",
        });

        setFiles([]);
        setProgress(100);
      } else {
        console.log(xhr)
        setUploadStatus({
          type: "error",
          message: "Error en el servidor al subir el archivo",
        });
      }

      setUploading(false);
    });

    xhr.addEventListener("error", () => {
      setUploadStatus({
        type: "error",
        message: "Error al subir el archivo",
      });
      setUploading(false);
    });

    xhr.open("POST", `${UrlApi}/proveedores/padron_contribuyentes/upload`);
    xhr.send(formData);
  } catch (error) {
    setUploadStatus({
      type: "error",
      message: "Error inesperado al procesar el archivo",
    });
    setUploading(false);
  }
};




  // //SOLAMENTE CARGA ARCHIVO OK !!!
  // const handleUpload = async () => {
  //   if (files.length === 0) return;

  //   const archivo = files[0];

  //   // ============================
  //   //  VALIDACIÓN DE TAMAÑO (600MB)
  //   // ============================
  //   const MAX_SIZE = 600 * 1024 * 1024;
  //   if (archivo.size > MAX_SIZE) {
  //     setUploadStatus({
  //       type: "error",
  //       message: "El archivo supera el tamaño máximo permitido (600MB)",
  //     });
  //     return;
  //   }

  //   // Comienza la subida
  //   setUploading(true);
  //   setProgress(0);
  //   setUploadStatus({ type: "info", message: "Subiendo archivo..." });

  //   try {
  //     const formData = new FormData();
  //     formData.append("files", archivo); // MULTER espera "files"

  //     const xhr = new XMLHttpRequest();

  //     // ============================
  //     //    PROGRESO DE SUBIDA
  //     // ============================
  //     xhr.upload.addEventListener("progress", (e) => {
  //       if (e.lengthComputable) {
  //         const percentComplete = Math.round((e.loaded / e.total) * 100);
  //         setProgress(percentComplete);
  //       }
  //     });

  //     // ============================
  //     //      RESPUESTA DEL SERVER
  //     // ============================
  //     xhr.addEventListener("load", () => {
  //       if (xhr.status === 200) {
  //         const resp = JSON.parse(xhr.responseText);

  //         setUploadStatus({
  //           type: "success",
  //           message: resp.message || "Archivo subido correctamente",
  //         });

  //         setFiles([]);
  //         setProgress(100);
  //       } else {
  //         setUploadStatus({
  //           type: "error",
  //           message: "Error en el servidor al subir el archivo",
  //         });
  //       }

  //       setUploading(false);
  //     });

  //     // ============================
  //     //       ERROR DE RED
  //     // ============================
  //     xhr.addEventListener("error", () => {
  //       setUploadStatus({
  //         type: "error",
  //         message: "Error al subir el archivo",
  //       });
  //       setUploading(false);
  //     });

  //     xhr.open("POST", `${UrlApi}/proveedores/padron_contribuyentes/upload`);
  //     xhr.send(formData);
  //   } catch (error) {
  //     setUploadStatus({
  //       type: "error",
  //       message: "Error inesperado al procesar el archivo",
  //     });
  //     setUploading(false);
  //   }
  // };

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(2px)",
      }}
    >
      <Box
        sx={{
          width: 650,
          maxHeight: "90vh",
          overflowY: "auto",
          backgroundColor: "white",
          borderRadius: 3,
          boxShadow: 6,
          p: 1,
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(135deg, #1F618D 0%, #0E3E5F 100%)",
            borderRadius: 2,
            p: 2.5,
            mb: 3,
            color: "white",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2} justifyContent="space-between">
            <Stack direction="row" spacing={1} alignItems="center">
              <CloudUploadIcon sx={{ fontSize: 28 }} />
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Carga de Padrón AFIP
              </Typography>
            </Stack>      
            <IconButton onClick={handleClose}>
              <CloseIcon sx={{ fontSize: 28, color:"#fff" }} />
            </IconButton>      
          </Stack>
        </Box>

        <Card sx={{ mb: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          <CardContent sx={{ p: 3 }}>
            <UploadBox
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current?.click()}
            >
              <CloudUploadIcon
                sx={{
                  fontSize: 48,
                  color: "#1F618D",
                  mb: 1.5,
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  color: "#1F618D",
                  fontWeight: 600,
                  mb: 0.5,
                }}
              >
                Arrastrá el padrón aquí
              </Typography>
              <Typography variant="body2" sx={{ color: "#7F8C8D" }}>
                o hacé clic para seleccionarlo
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#ABB2B9",
                  display: "block",
                  mt: 1,
                }}
              >
                Formato permitido: .tmp — Máx 600 MB
              </Typography>
            </UploadBox>

            <input
              ref={fileInputRef}
              type="file"
              hidden
              onChange={handleInputChange}
              accept=".tmp"
              multiple={false}
            />
          </CardContent>
        </Card>

        {/* Mensajes */}
        {uploadStatus && (
          <Alert
            severity={uploadStatus.type}
            sx={{ mb: 3, borderRadius: 1.5 }}
            icon={
              uploadStatus.type === "success" ? (
                <CheckCircleIcon />
              ) : (
                <ErrorIcon />
              )
            }
          >
            {uploadStatus.message}
          </Alert>
        )}

        {/* Archivo seleccionado */}
        {files.length > 0 && (
          <Card sx={{ mb: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Archivo seleccionado
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  backgroundColor: "#F4F6F6",
                  borderRadius: 1.5,
                  border: "1px solid #ABB2B9",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {files[0].name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#7F8C8D" }}>
                    {(files[0].size / 1024 / 1024).toFixed(2)} MB
                  </Typography>
                </Box>

                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => setFiles([])}
                  disabled={uploading}
                  sx={{ borderRadius: 1, textTransform: "none" }}
                >
                  Eliminar
                </Button>
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Progreso */}
        {uploading && (
          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
              <Typography variant="body2" sx={{ flex: 1, fontWeight: 500 }}>
                Cargando archivo…
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: "#1F618D" }}
              >
                {Math.round(progress)}%
              </Typography>
            </Box>

            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: "#E8F0F5",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#1F618D",
                  borderRadius: 4,
                },
              }}
            />
          </Box>
        )}

        {/* Botones */}
        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
          <Button
            variant="outlined"
            sx={{
              color: "#1F618D",
              borderColor: "#1F618D",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#F4F6F6",
                borderColor: "#0E3E5F",
              },
            }}
            onClick={() => setFiles([])}
            disabled={files.length === 0 || uploading}
          >
            Limpiar
          </Button>

          <Button
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #1F618D 0%, #0E3E5F 100%)",
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              "&:hover": {
                boxShadow: "0 6px 20px rgba(31,97,141,0.3)",
              },
            }}
            onClick={handleUpload}
            disabled={files.length === 0 || uploading}
          >
            {uploading ? "Cargando..." : "Subir archivo"}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ModalCargaPadron;
